import { SixTires } from './VehicleTypes/SixTires';
import { FourTires } from './VehicleTypes/FourTires';
import { GraderSixTires } from './VehicleTypes/GraderSixWheel';
import { TenTires } from './VehicleTypes/TenTires';
import { FourSixTires } from './VehicleTypes/FourSixTires';
import type { MakeModelDetails } from 'types/make-model.types';
import type {
  TirePattern,
  TirePatternPosition,
} from 'types/tire-pattern.types';
import type { Asset } from 'types/asset.types';
import { getDynamicAssetTireInfo } from 'views/TirePressure/util';

export const VehicleSelector = ({
  asset,
  tireData,
  limits,
  assetType,
  enableDarkTheme,
  unitSystem,
  tireCodes,
  metricType,
  makeModel,
  makeModelDetails,
  tirePatterns,
  customerId,
  batteryData,
  selectedAsset,
  onTireClick,
}: {
  asset: Asset | undefined;
  tireData: any;
  limits: any;
  assetType: string;
  enableDarkTheme: boolean;
  unitSystem: string;
  tireCodes: any;
  metricType: string;
  makeModel: string;
  makeModelDetails: MakeModelDetails[];
  tirePatterns: {
    tirePatterns: TirePattern[];
    tirePatternPositions: TirePatternPosition[];
  };
  customerId: string;
  batteryData: any;
  selectedAsset: any;
  onTireClick?: (tireCode: string) => void;
}) => {
  const assetTireDetails = getDynamicAssetTireInfo(
    makeModelDetails,
    tirePatterns.tirePatternPositions,
    asset?.make ?? '',
    asset?.model ?? '',
    customerId
  );

  const patternName = asset?.patternName ?? assetTireDetails.patternName;

  // `limits` is now the axleWiseLimits array: [{ make, model, positions[] }]
  // Find the entry for this asset's make/model and use its positions as per-tireCode limits.
  const makeModelEntry = Array.isArray(limits)
    ? limits.find(
        (e: any) => e.make === asset?.make && e.model === asset?.model
      )
    : null;
  const currentLimit: any[] = makeModelEntry?.positions ?? [];

  if (patternName === '6x4') {
    return (
      <SixTires
        tireData={tireData}
        limits={currentLimit}
        enableDarkTheme={enableDarkTheme}
        unitSystem={unitSystem}
        tireCodes={tireCodes}
        metricType={metricType}
        makeModel={makeModel}
        batteryData={batteryData}
        selectedAsset={selectedAsset}
        onTireClick={onTireClick}
      />
    );
  }
  if (patternName === '4x4') {
    return (
      <FourTires
        tireData={tireData}
        limits={currentLimit}
        enableDarkTheme={enableDarkTheme}
        unitSystem={unitSystem}
        tireCodes={tireCodes}
        metricType={metricType}
        makeModel={makeModel}
        batteryData={batteryData}
        selectedAsset={selectedAsset}
        onTireClick={onTireClick}
      />
    );
  }
  if (patternName === '6x6') {
    return (
      <GraderSixTires
        tireData={tireData}
        limits={currentLimit}
        enableDarkTheme={enableDarkTheme}
        unitSystem={unitSystem}
        tireCodes={tireCodes}
        metricType={metricType}
        makeModel={makeModel}
        selectedAsset={selectedAsset}
        batteryData={batteryData}
        onTireClick={onTireClick}
      />
    );
  }
  if (patternName === '10x6') {
    return (
      <TenTires
        tireData={tireData}
        limits={currentLimit}
        enableDarkTheme={enableDarkTheme}
        unitSystem={unitSystem}
        tireCodes={tireCodes}
        metricType={metricType}
        makeModel={makeModel}
        selectedAsset={selectedAsset}
        batteryData={batteryData}
        onTireClick={onTireClick}
      />
    );
  }
  if (patternName === '4x6') {
    return (
      <FourSixTires
        tireData={tireData}
        limits={currentLimit}
        enableDarkTheme={enableDarkTheme}
        unitSystem={unitSystem}
        tireCodes={tireCodes}
        metricType={metricType}
        makeModel={makeModel}
        selectedAsset={selectedAsset}
        batteryData={batteryData}
        onTireClick={onTireClick}
      />
    );
  }
  return <></>;
};
